var _g, _g2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLine61(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    baseProfile: "tiny",
    id: "Calque_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 120 77",
    overflow: "scroll",
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    fillRule: "evenodd",
    fill: "#00643C",
    width: 120,
    height: 77
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#FFFFFF",
    d: "M43.9351006,69.8173828c-16.3383999,0-22.1797009-11.3437843-22.1797009-27.1747818 c0-20.7407017,9.7353001-35.6402016,28.8676014-35.6402016c3.3862991,0,6.4335976,0.4233999,8.9736977,1.0162005 l-1.8628006,10.1585999C56.1254997,17.5,52.9931984,16.7378006,49.5224991,16.7378006 c-8.3808975,0-14.4761009,6.6879997-15.3227997,18.7094994c2.0317001-1.7784004,5.9258003-4.0634995,12.3599014-4.0634995 c9.9048004,0,17.8622971,6.517601,17.8622971,17.6923981C64.4218979,61.0126991,56.4644012,69.8173828,43.9351006,69.8173828z M42.75,40.7803001c-3.8096008,0-6.8568993,1.4393997-8.0424995,3.3017006 c-0.6772003,1.0156975-0.6772003,3.3857994-0.6772003,5.1641006c0,5.6718979,3.3017006,11.1737976,9.3969002,11.1737976 c5.9258003,0,8.9737015-4.8251991,8.9737015-9.9892006C52.4009018,44.8437004,48.6758003,40.7803001,42.75,40.7803001z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FFFFFF",
    d: "M81.6513977,68.3779297V21.3939991c-3.6396942,2.8785-9.3964996,5.6714001-13.3759995,7.4497013 l-4.0625-9.1429996c6.2637024-2.6240005,13.7988052-6.6030006,19.7246017-11.089901h10.4121017v59.767128H81.6513977z"
  })))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", null)));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLine61);
export default __webpack_public_path__ + "static/media/line-61.f17c1a806fda9f0d75c3f45c0d9d0d66.svg";
export { ForwardRef as ReactComponent };